'use strict';

import Axios from 'axios';
import { parseResponse, handleError } from '@/_helpers/utils.js';

export default {
  fetchModules() {
    return Axios.get('/1.0/company-module')
      .then(response => parseResponse(response).data)
      .catch(err => {
        throw handleError(err)
      });
  },

  updateModule(params) {
    return Axios.put('/1.0/company-module', { modules: [params] })
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err)
      });
  },

  requestModulePayment(params) {
    return Axios.post('/1.0/company-module', { modules: [params] })
      .then(response => parseResponse(response).data[0])
      .catch(err => {
        throw handleError(err)
      });
  }
};
